import { openAuthModal } from './header';

export const microfrontendsAPI = {
  header: { openAuthModal },
};
